import React, {useCallback, useEffect, useState} from 'react';
import {Outlet, useParams} from 'react-router-dom';
import _ from 'lodash';

import {connect, resourceActions} from 'redux/index.js';

import PageHeader from 'components/page-header';
import {loadProjects} from 'helpers/loaders';

import '../index.scss';
import lib from 'lib';

const Layout = ({projects, trackProjects}) => {
  const params = useParams();

  const [headerItems, setHeaderItems] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState();

  const projectId = parseInt(params.projectId);
  const project = _.find(projects, current => current.id === projectId);

  const styles = {
    header: {
      height: '50px',
      padding: '0 6rem 0 6rem',
    },
  };

  const fetchProjectData = useCallback(async (params) => {
    const projectId = parseInt(params.projectId);

    if (_.isNumber(projectId)) {
      const resourceActions = {trackProjects};
      const where = {id: projectId};

      await loadProjects({resourceActions, where});

      setIsLoading(false);
    }
  });

  //HINT populate redux store.resources.projects and set project for outlet context based on url params
  useEffect(() => {
    fetchProjectData(params);
  }, [params]);

  const fetchUserForToken = useCallback(async () => {
    const {data: {user}} = await lib.api.request({uri: 'user-for-token'});

    if (user) {
      setUser(user);
    }
  });

  //HINT fetches user data on initial mount
  useEffect(() => {
    fetchUserForToken();
  }, []);

  return (
    <div className='layout'>
      <PageHeader {...{project, user}} className='header' style={styles.header} items={headerItems}/>
      <Outlet context={[project, isLoading, setHeaderItems]} />
    </div>
  );
};

export default connect({
  mapState: state => {
    return {
      projects: state.resources.projects.byId,
    };
  },
  mapDispatch: {
    ..._.pick(resourceActions.projects, ['trackProjects']),
  }
})(Layout);
